export function getParamsFromUrl(queryParams) {
  return queryParams.split('&').reduce((result, queryParam) => {
    try {
      const [name, stringValue] = decodeURIComponent(queryParam).split('=');
      return {
        ...result,
        [name]: stringValue.split(';'),
      };
    } catch (ex) {
      return result;
    }
  }, {});
}

const filterFacetsByTitle = (facets, title) => facets.filter(facetItem => facetItem.title === title);

export const getFacetsToRender = (sectionTitle, facet) =>
  sectionTitle ? filterFacetsByTitle(facet.items, sectionTitle) : facet.items;
